import {IFilterFunction} from "angular";
import {languageClass, TranslationsLanguage} from "../../config/TranslationsLanguage";

export const LanguageClassPipe = "tfLanguageClass";

export function languageClassPipe(): IFilterFunction {
    return (language: TranslationsLanguage | null) => {
        if (language == null) {
            return null;
        } else {
            return languageClass(language);
        }
    };
}
